window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');

// Suppress console logs on production domain
if (window.suppressConsoleLogs) {
    /* eslint-disable no-console */
    console.log = () => {};
    console.warn = () => {};
    console.error = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.trace = () => {};
    document.addEventListener('DOMContentLoaded', () => console.clear());
    /* eslint-enable no-console */
}

const { initCarousel } = require('./components/carousel');
const { initLiveChat } = require('liveagent/liveagent');
const { initSMS } = require('liveagent/sms');
const { initEmailLightbox } = require('./components/emailLightbox');
const { initPopoverAll } = require('./popover');
const { init: initFlexTabs } = require('./components/flexTabs');
const { init: initShowMore } = require('./components/showMore');
const { queryAll, hasClass } = require('./domUtil');
const { initCsrfRefresh } = require('./utils/csrfRefresh');
const notifyMe = require('./components/notifyMe').default;
const productDetail = require('./product/detail').default;
const $body = $('body');
const bodyEl = $body[0];
const scrollBarWidth = `${window.innerWidth - bodyEl.scrollWidth}px`;
const { initFocusScrollFix } = require('./components/focusinScroll');
const initInputModalityToggle = require('./components/interactionDetect');

require('./components/announce');
require('./polyfill');
require('./jquery.plugins.js');
require('bootstrap/js/src/popover');
require('bootstrap/js/src/dropdown.js');
require('jquery-zoom');

document.addEventListener('DOMContentLoaded', () => {
    initCsrfRefresh();
    processInclude(require('./components/menu'));
    processInclude(require('base/components/cookie'));
    processInclude(require('base/components/consentTracking'));
    processInclude(require('./components/footer'));
    processInclude(require('./components/miniCart'));
    processInclude(require('./components/headerSearch'));
    processInclude(require('./components/heroLogo'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./clientSideValidation'));
    processInclude(require('base/components/countrySelector'));
    processInclude(require('./components/modal'));
    processInclude(require('./components/toolTip'));
    initPopoverAll();
    processInclude(require('./postLogin/postLogin'));
    processInclude(require('./components/video').default);
    processInclude(require('./product/sizeChart'));
    processInclude(require('./product/wishlist'));
    processInclude(require('./components/csrfErrorModal'));
    processInclude(require('./components/serviceWorkerDeRegistration'));
    processInclude(require('./components/textAreaCounter'));
    processInclude(require('./components/postalCode'));
    processInclude(require('./imageLazyLoad'));
    processInclude(require('./scriptLazyLoad'));
    processInclude(require('./loyalty/loyaltyDrawer'));
    processInclude(require('./stickyGwpDrawer'));
    processInclude(require('./components/updateURLPath'));
    processInclude(require('./onetrust'));
    processInclude(require('./components/pillsMenu'));
    processInclude(require('./components/accordion'));
    processInclude(require('./exposedFunctions'));
    processInclude(require('./togglePassword'));
    processInclude(require('./components/selectFloatingLabel'));
    processInclude(require('./login/login'));
    processInclude(require('./account/preferredStore'));
    processInclude(require('./loyaltySnapshot'));
    processInclude(require('./onetrust/clearCookies.js'));
    initEmailLightbox();
    initCarousel();
    initLiveChat();
    initSMS();
    initFlexTabs();
    initShowMore();
    processInclude(notifyMe);
    processInclude(productDetail.sizeChart);
    initInputModalityToggle();
    // global as now it used for minicart
    processInclude(require('./productTile'));
    processInclude(require('./components/timer'));
    require('./oosProductAlternativesSheet.js');

    $('.invalid-feedback').attr('role', 'alert');
    $body.css('--scrollbar-width', scrollBarWidth);
});

const { initCarousels } = require('./components/swiperCarousel').default;

initCarousels(queryAll('.js-slot'));
// TODO: remove after PLP PD integration — Highlight Slider Layout carousels (not wrapped in .js-slot)
initCarousels(queryAll('.pd-highlight.js-carousel-wrapper'));
initFocusScrollFix();

// Add an event listener on the document with delegation to elements with the class js-slot
document.addEventListener('slot-loaded', function (e) {
    const { target } = e;
    if (hasClass(target, 'js-slot')) {
        initCarousels(target);
    }
});

require('./thirdParty/bootstrap');
require('./components/spinner');
require('./components/staggeredContent');
// Include Stylitics Insights Analytics global as it is used for minicart
require('./styliticsInsightsAnalytics.js');
